import { namespace } from '../constants'
import { prop, compose } from 'ramda'

const root = prop(namespace)
// user selectors
export const user = compose(
  prop('currentUser'),
  root
)
export const email = compose(
  prop('email'),
  user
)
export const thumbnailPhoto = compose(
  prop('thumbnailPhoto'),
  user
)
export const entityUserGuid = compose(
  prop('entityUserGuid'),
  user
)
export const firstName = compose(
  prop('firstName'),
  user
)
export const lastName = compose(
  prop('lastName'),
  user
)
